import { SettingConst } from '../../types';

/**
 * Shows a banner on mobile web with a sign-up CTA.
 */
export const SIGNUP_CTA_MOBILE_WEB_BANNER_240806 =
  'SIGNUP_CTA_MOBILE_WEB_BANNER_240806' as SettingConst<
    'SIGNUP_CTA_MOBILE_WEB_BANNER_240806',
    boolean,
    'RETAILER'
  >;
